/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  tableHeadCell: {
    cursor: 'pointer',
    paddingTop: '.625rem',
    paddingBottom: '.625rem',
    color: theme.palette.mainText,
    fontWeight: 700,
    // Checkbox
    '& th:first-child': {
      width: '3.2rem',
    },
    '& div ': {
      display: 'flex',
      minWidth: '0',
      alignItems: 'center',
    },
    '& div span:not([class])': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
  tableHeadActionCell: {
    width: '6.25rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  addressBookCell: {
    '& th:first-child': {
      width: '10rem',
    },
  },
  combinedColumn: {
    display: 'flex',
    justifyContent: 'space-around',
  },

  noRightBorder: {
    borderRight: '0',
  },
  unwrappedTableCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingTop: '.625rem',
    paddingBottom: '.625rem',
  },
  iconColorContainer: {
    position: 'relative',
    top: '.25rem',
    left: '1rem',

    '&[data-focustype="key"]': {
      outlineColor: `${theme.palette.focus}`,
    },

    '&:focus': {
      outlineColor: 'none',
    },
  },
  actionRow: {
    width: '10rem !important',
  },
}));

export default useStyles;
